// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2754":"47ba61d4","3753":"8c5648c8","9250":"e17e6fec"}[chunkId] + ".css";
};